<template>
  <div class="ls-table-wrapper">
    <div class="ls-table-inner" ref="tableInner">
      <table class="ls-table">
        <thead>
          <tr>
            <th></th>
            <th v-for="h in tableLayout.header">
              <div class="cell-inner">{{ h }}</div>
            </th>
          </tr>
        </thead>
        <tbody v-if="rows.length > 0">
          <tr v-for="r in tableDataSlice">
            <th>
              <div class="cell-inner">{{ r.key }}</div>
            </th>
            <td v-for="v in r.data">
              <div class="cell-inner">{{ v }}</div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th class="tfoot-header">TOTALS</th>
            <td class="tfoot-data" v-for="v in totals.data">
              <div class="cell-inner">{{ v }}</div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-if="rows.length > pageSize" class="ls-table-pagination">
      <button
        class="btn btn-primary"
        :disabled="currentPage == 0"
        @click="currentPage--"
      >
        <i class="fa fa-arrow-left"></i> prev
      </button>
      |
      <button
        class="btn btn-primary"
        :disabled="currentPage >= lastPage"
        @click="currentPage++"
      >
        next <i class="fa fa-arrow-right"></i>
      </button>
      <span v-if="lastPage >= 0"
        >page {{ currentPage + 1 }} of {{ lastPage + 1 }}</span
      >
      <span
        ><small>({{ rows.length }} items)</small></span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    tableLayout: {
      type: Object,
      default: function () {
        return {};
      },
    },
    bcOptions: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    rows() {
      return this.tableData.slice(0, -1);
    },
    totals() {
      return this.tableData.slice(-1)[0];
    },
    showPagination() {
      return this.rows.length > this.pageSize;
    },
    lastPage() {
      return Math.ceil(this.rows.length / this.pageSize) - 1;
    },
    tableDataSlice() {
      var cursor = this.currentPage * this.pageSize;
      return this.rows.slice(cursor, cursor + this.pageSize);
    },
  },
  data: function () {
    return {
      defaultOptions: {
        displayModeBar: false,
      },
      currentPage: 0,
      pageSize: 10,
    };
  },
  created() {
    this.$parent.$on("heightResized", this.calculatePageSize);
    this.calculatePageSize();
  },
  watch: {
    tableData: function (current, old) {
      this.currentPage = 0;
    },
  },
  methods: {
    calculatePageSize: _.debounce(function () {
      if (this.$refs.tableInner) {
        let firstTr = this.$refs.tableInner.firstChild.firstChild.firstChild;
        if (firstTr) {
          let h = firstTr.clientHeight;
          let viewportH = this.$refs.tableInner.clientHeight;
          let maxRows = Math.floor(viewportH / h) - 2;
          this.pageSize = Math.ceil(maxRows);
        } else {
          this.pageSize = 0;
        }
      }
    }, 100),
    mergeDicts: function (defaultDict, newDict) {
      for (var key in this.newDict) {
        defaultDict[key] = this.newDict;
      }
      return defaultDict;
    },
  },
};
</script>

<style lang="scss" scoped>
$inside-border: 1px solid #eee;
$strong-border: 2px solid #666;

.ls-table-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  background: #fff;

  .ls-table-inner {
    overflow-y: auto;
    flex: 1;

    table.ls-table {
      font-family: "Roboto Mono", "Inconsolata", monospace;
      font-size: 90%;
      border-collapse: collapse;
      width: 100%;
      border-bottom: $strong-border;

      .cell-inner {
        line-height: 2em;
        margin: auto;
        padding: 1px 4px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: bottom;
      }

      thead {
        border-bottom: $strong-border;

        th {
          text-align: right;
          border-right: $inside-border;
          vertical-align: middle;

          &:last-child {
            border-right: none;
          }
        }
      }

      tbody {
        tr {
          border-bottom: $inside-border;
          th {
            border-right: $inside-border;
          }

          td {
            text-align: right;
            border-right: $inside-border;

            &:first-child {
              text-align: left;
            }
            &:last-child {
              border-right: none;
            }
          }
        }
      }

      tfoot {
        tr {
          border-top: $strong-border;
          background: #ecfbfb;

          th.tfoot-header {
            text-align: left; // This was changed to align "TOTALS" to the left
            border-right: $inside-border;
          }

          td.tfoot-data {
            text-align: right; // align data to the right
            border-right: $inside-border;
            color: #2c3e50; // change color to make it different
            font-weight: bold; // make it bold to make it different

            &:first-child {
              text-align: right;
            }
            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }
  }

  .ls-table-pagination {
    flex: 0;
    width: 100%;
    background: #fafafa;
    padding: 3px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// LsTable.vue?62daf7ce